var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolatilityLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.51 16.006c.33-.034.661.076.907.301l3.207 2.95a1.164 1.164 0 11-1.577 1.714l-2.239-2.06-3.242 4.521a1.164 1.164 0 01-1.893 0l-3.146-4.386-3.845 4.467a1.164 1.164 0 01-1.829-.08l-3.012-4.2-2.68 4.152a1.165 1.165 0 01-1.893.09l-3.676-4.66-2.69 2.2a1.164 1.164 0 01-1.475-1.802l3.609-2.95a1.164 1.164 0 011.65.18l3.402 4.31 2.724-4.22a1.164 1.164 0 011.925-.047l3.146 4.386 3.845-4.467a1.165 1.165 0 011.828.08l3.063 4.27 3.063-4.27c.195-.27.496-.445.827-.479z"
  })));
}
export default SvgVolatilityLow;